import React, { PropTypes } from 'react';
import { Checkbox } from 'material-ui';
import { connect } from 'react-redux';
import TypeControlledTextField from '../../../tc-ui/type-controlled-textfield.jsx';
import StayPay from '../staypay.jsx';
import DaysOfWeek from '../days-of-week';
import { rateSetNamesMapAccommo, rateSetNamesMapNonAccommo } from '../../../../utils/contracting-preset-names-codes';
import Select from 'react-select';
import R from 'ramda';

const RateSetInfo = props => {
  const {
    updateFieldValue,
    updateDaysOfWeek,
    productType,
    productName,
    rateSetName,
    rateSetCode,
    maxFOC,
    stayPays,
    stayDays,
    payDays,
    stayPayError,
    staypayApplicable,
    rateSetNameAndCodeError,
    overlappingDaysError,
    openAddEditContractDialog,
    rateSetsIndex,
    } = props;
  const openDialogForCreatingNewRatePackage = () => openAddEditContractDialog({ type: 'manageRatePackage', title: `Create Rate Package for ${productName}` });
  const rateSetNamesMap = productType === 'Accommodation' ? rateSetNamesMapAccommo : rateSetNamesMapNonAccommo;
  const updatedRateSetNamesMap = {
    ...(productType === 'Accommodation' ? {} : { Standard: 'ie STANDARD' }),
    [productName]: productType === 'Accommodation' ? 'ie DBLSTNDRD' : 'ie HRBCRS1HR',
    ...rateSetNamesMap,
  };
  const rateSetNames = Object.keys(updatedRateSetNamesMap);
  const rateSetNamesOptions = rateSetNames.map(name => ({ label: name, value: name }));

  return (
    <div>
      <label style={{ width: '80%' }}>
        Please select a rate set name to help agents quickly identify the applicable rate for a booking.
      </label><br/>
      <span style={{ color: 'red', display: 'block', width: '95%' }}>{rateSetNameAndCodeError}</span>
      <div>
        <div style={{ float: 'left', width: '32%', marginTop: '30px', zIndex: '1' }}>
          <Select
            name="rateSetName"
            options={rateSetNamesOptions}
            value={rateSetName}
            onChange={({ value }) => {
              updateFieldValue('rateSetName', value);
            }}
            placeholder="Rate set name"
            clearable={false}
            scrollMenuIntoView={false}
          />
        </div>
        <span style={{ color: 'red', marginLeft: '10px', fontSize: '24px', verticalAlign: 'bottom' }}> *</span>
        <TypeControlledTextField
          limitLength={11}
          id={`rateSetCode${rateSetsIndex}`}
          style={{ marginLeft: '24px' }}
          floatingLabelText="Rate set code / Description"
          floatingLabelShrinkStyle={{ color: 'rgba(0, 0, 0, 0.64)' }}
          hintText={updatedRateSetNamesMap[props.rateSetName] || 'ie Weekly Rates or Weekend Rates'}
          value={rateSetCode || ''}
          onChange={({ target: { value } }) => {
            updateFieldValue('rateSetCode', value);
          }}
        />
      </div>

      <br />
      <div style={{ color: 'red', marginBottom: '16px' }}>{overlappingDaysError}</div>
      {
        overlappingDaysError ? (<div style={{ marginBottom: '16px', color: 'red', fontSize: '13px' }}>
          {
            productType === 'Accommodation' ? `In order to have two types of rates for the same days of the week, please either adjust the min/max night stays (so they aren't overlapping), or use a rate package.`
              : `Please either adjust the days of the week (so they aren't overlapping), or use a rate package.`
          }&nbsp;
          Click <a onClick={openDialogForCreatingNewRatePackage} style={{ cursor: 'pointer' }}>here</a> to create a rate package for this {productType === 'Accommodation' ? 'room' : 'product'}.
        </div>) : <div/>
      }
      {
        productType === 'Accommodation' ? (
          <div>
            <label style={{ zIndex: '0' }}>
              Please note the minimum or maximum night restrictions, if any, for a booking to be eligible for these rates.
            </label>
            <span style={{ color: 'red', display: 'block', width: '95%' }}>
              {props.maxStay && props.minStay && Number(props.maxStay) < Number(props.minStay) && 'Max night stay should be greater than min night stay.'}
            </span>
            <TypeControlledTextField
              controlledType="number"
              id={`minStay${rateSetsIndex}`}
              style={{ display: 'inline-block', width: '160px', zIndex: '0' }}
              hintStyle={{ fontSize: '12px' }}
              inputStyle={{ fontSize: '14px' }}
              floatingLabelShrinkStyle={{ color: 'rgba(0, 0, 0, 0.64)' }}
              floatingLabelText="Min night stay"
              hintText="Min night stay"
              value={props.minStay}
              onChange={({ target: { value } }) => updateFieldValue('minStay', value)}
            />
            <TypeControlledTextField
              controlledType="number"
              id={`maxStay${rateSetsIndex}`}
              style={{ display: 'inline-block', width: '160px', marginLeft: '30px', zIndex: '0' }}
              hintStyle={{ fontSize: '12px' }}
              inputStyle={{ fontSize: '14px' }}
              floatingLabelShrinkStyle={{ color: 'rgba(0, 0, 0, 0.64)' }}
              floatingLabelText="Max night stay"
              hintText="Max night stay"
              value={props.maxStay}
              onChange={({ target: { value } }) => updateFieldValue('maxStay', value)}
            />
            <br />
          </div>
        ) : undefined
      }
      {
        productType === 'Accommodation' && stayPays && stayPays.filter(R.both(R.prop('stayDays'), R.prop('payDays'))).length ? <StayPay
          staypayApplicable={staypayApplicable}
          stayPayError={stayPayError}
          stayPays={stayPays}
          stayDays={stayDays}
          payDays={payDays}
          maxFOC={maxFOC}
          updateFieldValue={updateFieldValue}
        /> : <div></div>
      }
      <br />

      <label>Which day(s) of the week do these rates apply to?</label><span style={{ color: 'red', zIndex: '0', fontSize: '24px', verticalAlign: 'bottom' }}> *</span>
      <br />
      <br />
      <DaysOfWeek
        daysOfWeek={props.daysOfWeek}
        updateDaysOfWeek={updateDaysOfWeek}
      />
    </div>
  );
};

RateSetInfo.propTypes = {
  updateFieldValue: PropTypes.func,
  updateDaysOfWeek: PropTypes.func,
  minStay: PropTypes.node,
  maxStay: PropTypes.node,
  rateSetName: PropTypes.string,
  daysOfWeek: PropTypes.array,
  productType: PropTypes.string,
  productName: PropTypes.string,
  rateSetCode: PropTypes.string,
  openAddEditContractDialog: PropTypes.func,

};

export default connect(null, {
  openAddEditContractDialog: payload =>({ type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE', payload })
})(RateSetInfo);


// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/rate-forms/rate-set-info-template.jsx